import { useLocation } from 'react-router-dom';

export function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export function getQuery(location) {
  return new URLSearchParams(location.search);
}
